import React from 'react';
import styled from 'styled-components';
import { Row } from '../Flex';
import { ComboBoxResponsive } from '../ui/combobox';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';

type Props = {
  selectedTags: { label: string; value: string }[];
  selectedOperatingSystems: { label: string; value: string }[];
  allTags: string[];
  allOperatingSystems: string[];
  onlyAvailableBots: boolean;
  onChangeTags: (e) => void;
  onChangeOperatingSystems: (e) => void;
  onChangeAvailableBots: (e) => void;
};

const capitalizeFirstLetterAfterSpace = (str: string) => {
  return str
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
};

const Container = styled(Row)`
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const BotsFilters = (props: Props) => {
  return (
    <Container className="flex flex-col sm:flex-row justify-start gap-2 sm:gap-4">
      <ComboBoxResponsive
        onChange={props.onChangeTags}
        value={props.selectedTags}
        data={props.allTags.map((tag) => {
          return {
            label: capitalizeFirstLetterAfterSpace(tag),
            value: tag,
          };
        })}
        placeholder="Compatible Sites"
      />
      <ComboBoxResponsive
        onChange={props.onChangeOperatingSystems}
        value={props.selectedOperatingSystems}
        data={props.allOperatingSystems.map((os) => {
          return {
            label: capitalizeFirstLetterAfterSpace(os),
            value: os,
          };
        })}
        placeholder="Operating Systems"
      />
      <div className="flex gap-2 h-10">
        <div className="flex items-center space-x-2">
          <Switch
            id="show-available"
            checked={props.onlyAvailableBots}
            onCheckedChange={props.onChangeAvailableBots}
          />
          <Label htmlFor="show-non-partnered">Available</Label>
        </div>
      </div>
    </Container>
  );
};

export default BotsFilters;
